// Выбор варианта PDF: с водяным знаком или без (экономия чернил при печати)

import React from 'react';
import { Dialog, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';

export default function PdfWatermarkDialog({ open, onClose, onSelectWithWatermark, onSelectWithoutWatermark }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '0.75rem',
          overflow: 'hidden',
          boxShadow: '0 1.5rem 4rem rgba(0,0,0,0.15)',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 2, borderBottom: '0.0625rem solid #f0f0f0' }}>
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#212121', lineHeight: 1.2 }}>
            Чертёж PDF
          </Typography>
          <Typography sx={{ fontSize: '0.72rem', color: '#9e9e9e', mt: 0.25 }}>
            Водяной знак на листе
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ color: '#9e9e9e', '&:hover': { color: '#212121', background: '#f5f5f5' } }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={{ display: 'flex', gap: 1.5, p: 2.5 }}>
        <Box
          onClick={onSelectWithWatermark}
          sx={{
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.25,
            p: 2.5, borderRadius: '0.6rem', cursor: 'pointer',
            border: '0.125rem solid #e8e8e8',
            background: '#fafafa',
            transition: 'all 0.15s',
            '&:hover': {
              border: '0.125rem solid #d32f2f',
              background: '#fff5f5',
              boxShadow: '0 0.25rem 1rem rgba(211,47,47,0.1)',
              transform: 'translateY(-0.1rem)',
            },
          }}
        >
          <Box sx={{
            width: '3rem', height: '3rem', borderRadius: '0.75rem',
            background: 'linear-gradient(135deg, #e8e8e8, #f5f5f5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <PictureAsPdfIcon sx={{ fontSize: '1.6rem', color: '#616161' }} />
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#212121', mb: 0.4 }}>
              С водяным знаком
            </Typography>
            <Typography sx={{ fontSize: '0.78rem', color: '#616161', lineHeight: 1.45 }}>
              Как на экране — для заказчика и архива
            </Typography>
          </Box>
        </Box>

        <Box
          onClick={onSelectWithoutWatermark}
          sx={{
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.25,
            p: 2.5, borderRadius: '0.6rem', cursor: 'pointer',
            border: '0.125rem solid #e8e8e8',
            background: '#fafafa',
            transition: 'all 0.15s',
            '&:hover': {
              border: '0.125rem solid #2e7d32',
              background: '#f1f8f4',
              boxShadow: '0 0.25rem 1rem rgba(46,125,50,0.12)',
              transform: 'translateY(-0.1rem)',
            },
          }}
        >
          <Box sx={{
            width: '3rem', height: '3rem', borderRadius: '0.75rem',
            background: 'linear-gradient(135deg, #c8e6c9, #e8f5e9)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <PrintIcon sx={{ fontSize: '1.6rem', color: '#2e7d32' }} />
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#212121', mb: 0.4 }}>
              Без водяного знака
            </Typography>
            <Typography sx={{ fontSize: '0.78rem', color: '#616161', lineHeight: 1.45 }}>
              Чистый лист — меньше расход чернил при печати
            </Typography>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}
